import { Link, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton } from "components/ui";
import { getDefault, getWorkflowSteps } from "components/workflows/AdvancedAlertsAddPhoneWorkflow";
import { SVGAsset } from "res";

import UIPhoneNumberWithFormat from "components/ui/UIPhoneNumberWithFormat";
import "./styles.css";

export default function AddPhoneContent(props) {
    const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
    const { phone } = workflowStep.getStepState;

    const onChange = value => workflowStep.update([ "phone" ], value);
    const onSubmit = evt => {
        const recipient = !phone || phone.length === 0 || phone.replace(/[\s()-]/g, "").length !== 10
            ? "(508) 123-4567" : phone;

        workflowStep.workflow.nextStep({ recipient });
    };

    return (
        <div className="add-phone-content back-link-padding">
            <Link to="/advancedAlerts/manageRecipients" className="back-link">
                <span><SVGAsset id="LeftChevronIcon" /> Back</span>
            </Link>

            <p className="page-subtitle">Add Phone</p>

            <FormContainer className="small-form-width">
                <FormRowView text="Phone Number *">
                    <UIPhoneNumberWithFormat value={ phone } onChange={ onChange } placeholder="(###) ###-####" />
                </FormRowView>

                <FormButtonRow>
                    <UIButton className="primary-button set-width" text="Submit" onClick={ onSubmit } />
                </FormButtonRow>
            </FormContainer>
        </div>
    );
}